import React from 'react'

import Theme from './Themes'
import Window from './Window'

import GlobalStyle from './GlobalStyle'
import '../assets/styles.css'
import * as S from './styled'

const Layout = ({ brand, mobile }) => {
  return (
    <React.Suspense fallback={<div />}>
      <Theme brand={brand}>
        <>
          <GlobalStyle />
          <S.Main>
            <Window brand={brand} mobile={mobile} />
          </S.Main>
        </>        
      </Theme>
    </React.Suspense>
  )
}

export default Layout
